import type { IEvent } from 'bz-utilities/modules/plugins/register/stores/mediator';
import { TaskResponse } from 'tm3-core/api.dtos';

export class TaskUpdateEvent implements IEvent {
  task: TaskResponse = new TaskResponse();
  isNew: boolean = false;
  isDeleted: boolean = false;

  public constructor(init?: Partial<TaskUpdateEvent>) {
    (Object as any).assign(this, init);
  }
}

export class AddTaskEvent implements IEvent {
  patientId?: number;
  patientName?: string;
  title?: string;
  description?: string;

  public constructor(init?: Partial<AddTaskEvent>) {
    (Object as any).assign(this, init);
  }
}
